import { RootState } from "@store/index";
import { createSelector } from "reselect";
import { DialogState } from "../reducers/dialogReducer";

const state = (state: RootState) => state.dialog as DialogState;

export const selectIsDialogOpen = createSelector([state], (state) => state.isOpen);
